<app-breadcrumb
  [master]="'Dobry Agent'"
  [parentName]="'Kategorie'"
  [name]="'Szczegóły'"
></app-breadcrumb>

<mat-tab-group>
  <mat-tab label="Dane">
    <app-da-category-details-view
      *ngIf="!modify"
      [blogCategory]="blogCategory"
      (modifyClicked)="modify = true"
    ></app-da-category-details-view>

    <app-da-category-add
      *ngIf="modify && blogCategoryObject"
      [blogCategory]="blogCategoryObject"
      [mod]="true"
      (closeModification)="modify = false; load()"
    ></app-da-category-add>
  </mat-tab>
  <mat-tab label="Kolejność artykułów">
    <app-da-category-article-order
      *ngIf="blogCategoryObject"
      [blogCategory]="blogCategoryObject"
    ></app-da-category-article-order>
  </mat-tab>
</mat-tab-group>
